import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { U2bApiService } from './u2b-api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SalutationNew } from '@shared/models/salutation';
import { AppUser } from '../user.service';
import { IFile } from '@shared/interfaces/file';

export interface User {
    id: string;
    salutation: SalutationNew;
    title: string;
    firstName: string;
    lastName: string;
    emailHash?: string;
    email: string;
    email2: string;
    phone: string;
    mobilePhone: string;
    street: string;
    postcode: string;
    city: string;
    country: string;
    birthDate: Date;
    image: IFile;
}

@Injectable({providedIn: 'root'})
export class U2bUserApiService extends U2bApiService {

    protected constructor(_http: HttpClient) {
        super(_http);
    }

    getCurrent(params: HttpParams = new HttpParams()): Observable<AppUser> {
        return super.get<AppUser>('users/current', params);
    }

    // TODO-SEC This is fine for now, since a UUID is passed, but should be resolved via user token.
    // This should be refactored. In some tables, user names are fetched one-by-one via ID.
    getOneById(userId: string, params: HttpParams = new HttpParams()): Observable<User> {
        return super.get<User>(`users/${userId}`, params);
    }

    updateCurrent(dto: Partial<User>, params: HttpParams = new HttpParams()): Observable<AppUser> {
        return super.put<AppUser>('users/current', dto, params);
    }

}
